import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { MeetingsService } from '../services/meetings.service';
import { EmployeeService } from '../employee.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'ngx-edit-meeting',
  templateUrl: './edit-meeting.component.html',
  styleUrls: ['./edit-meeting.component.scss'],
})
export class EditMeetingComponent implements OnInit {
  @Input() stationId: string;
  @Input() meeting: any;
  _meeting: any = {
    place: '',
    date: new Date(),
    object: '',
    cases: [],
    participants: [],
    agreements: [],
    next_meeting: new Date(),
  };
  filteredOptions: Observable<any[]>;
  loadingEmployees = false;
  myControl = new FormControl();
  options = [];
  loading = true;

  constructor(
    protected ref: NbDialogRef<EditMeetingComponent>,
    private meetingService: MeetingsService,
    private employeeService: EmployeeService,
    private toastrService: NbToastrService
  ) { }

  async ngOnInit() {
    this._meeting = { ...this.meeting };
    this._meeting.date = new Date(this._meeting.date._seconds * 1000);
    this._meeting.next_meeting = new Date(this._meeting.next_meeting._seconds * 1000);
    this._meeting.agreements = this._meeting.agreements.map((el: any) => ({ ...el, commitment_date: new Date(el.commitment_date._seconds * 1000) }))
    this.loading = false;
    await this.getEmployees();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.options.slice())
      );
  }

  displayFn(user?: any): string | undefined {
    return user ? user.name : undefined;
  }

  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }

  async getEmployees() {
    this.loadingEmployees = true;
    const [error, res] = await this.employeeService.getEmployees(this.stationId);
    if (error) return error;

    this.options = res.data.map((el: any) => ({ name: el.name + ' - ' + el.role, id: el.id, role: el.role, _name: el.name }));
    this.loadingEmployees = false;
  }


  close() {
    this.ref.close();
  }

  addCase() {
    this._meeting.cases.push('');
  }

  removeCase(i) {
    this._meeting.cases.splice(i, 1);
  }

  addParticipant() {
    if (typeof this.myControl.value !== 'object' || this.myControl.value === null) return this.showToast('Selecciona un empleado de la lista', 'danger');
    const isAdded = this._meeting.participants.find((el: any) => el.id === this.myControl.value.id);
    if (isAdded) return this.showToast('Ya agregaste este empleado', 'warning');
    this._meeting.participants.push({
      name: this.myControl.value._name,
      id: this.myControl.value.id,
      role: this.myControl.value.role
    });
    this.myControl = new FormControl();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.options.slice())
      );
  }

  removeAgregment(i) {
    this._meeting.agreements.splice(i, 1);
  }

  removeParticipant(i) {
    this._meeting.participants.splice(i, 1);
  }

  async edit() {
    const [error] = await this.meetingService.updateMeeting(this.stationId, this._meeting, this._meeting.id);
    // tslint:disable-next-line: max-line-length
    if (error) return this.alert('Ocurrio un error al intentar actualizar la información, intenta más tarde por favor', 'error');
    this.alert('Minuta guardada con éxito');
    this.ref.close(true);
  }


  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  showToast(message, _status) {
    const position: any = "bottom-right";
    const status: any = _status;
    this.toastrService.show(
      message,
      'Oops',
      { position, status });
  }

}
